import {Button} from '@chekinapp/ui';
import Lottie from 'lottie-react';
import {useLocation, useNavigate} from 'react-router-dom';
import {SquareArrowOutUpRight, HomeIcon} from 'lucide-react';
import {PATHS} from 'routes/constants';
import {goToExternalLink} from 'utils/common';
import {useTranslation} from 'react-i18next';
import {useCheckoutSettings} from '../hooks/useCheckoutSettings';
import {usePath} from 'hooks';
import {useSummary} from 'context/summary';
import {useCustomLotties} from '@chekin/shared';
import {SimplePage} from 'components/SimplePage';
import {Mozio} from 'components/upselling/Mozio';

function ThanksView() {
  const {t} = useTranslation('check-out');
  const {getFullPath} = usePath();
  const navigate = useNavigate();
  const {data: summary} = useSummary();
  const {checkoutSettings, isLoading, hasMozio} = useCheckoutSettings();
  const {checkinCompletedAnimation} = useCustomLotties();
  const {state} = useLocation();
  const minimumNpsScore = checkoutSettings?.survey_minimum_nps_score ?? 0;
  const totalExternalPlatforms = checkoutSettings?.survey_external_urls?.length ?? 0;
  const rating = state?.rating ?? 0;

  const hasPlatformsReviews = totalExternalPlatforms > 0 && rating >= minimumNpsScore;

  const hasNoPlatformsAndMozios = !hasPlatformsReviews && !hasMozio;

  const goToHomepage = () => {
    navigate(getFullPath(PATHS.home));
  };
  return (
    <SimplePage
      title={t('thanks_staying_with_us')}
      description={hasPlatformsReviews ? t('thanks_staying_with_us_description') : ''}
      className="thanks-view"
      isLoading={isLoading}
    >
      <div className="flex flex-col gap-[48px] max-w-[900px] m-auto items-center thanks-view__container">
        {hasPlatformsReviews && (
          <div className="flex flex-col gap-6 w-full md:max-w-[295px] platform-buttons__container">
            {checkoutSettings?.survey_external_urls?.map((surveyExternalUrl, index) => {
              return (
                <Button
                  variant="outline"
                  className="gap-2 platform-button__go-to-review"
                  onClick={() => goToExternalLink(surveyExternalUrl.url)}
                  key={index}
                >
                  <SquareArrowOutUpRight size={15} />
                  {t('platform_review', {name: surveyExternalUrl.name})}
                </Button>
              );
            })}
          </div>
        )}
        {hasMozio && (
          <div className="flex flex-col gap-4 items-center platform-upselling__container w-full">
            <div className="font-bold text-lg text-left md:text-center w-full platform-upselling__title">
              {t('ready_for_your_trip_back')}
            </div>
            {summary?.id && (
              <div className="w-full">
                <Mozio housingId={summary.id} />
              </div>
            )}
          </div>
        )}

        {hasNoPlatformsAndMozios && (
          <div className="flex flex-col gap-6 items-center platform-upselling__container">
            <div className="w-[150px] h-[150px] platform-upselling__animation">
              <Lottie animationData={checkinCompletedAnimation} />
            </div>
            <div className="font-bold text-lg text-left md:text-center w-full platform-upselling__title">
              {t('online_checkout_is_completed')}
            </div>
          </div>
        )}
        <Button
          className="gap-2 w-full md:max-w-[295px] platform-button__return-to-home-page"
          onClick={goToHomepage}
        >
          <HomeIcon size={16} className="platform-button__home-icon" />

          {t('return_to_homepage')}
        </Button>
      </div>
    </SimplePage>
  );
}

export default ThanksView;
